import { createSlice } from "@reduxjs/toolkit";
import { constant } from "common/constant";
import { getApi } from "common/services/api"; 
import { API_PATHS } from "common/services/apiPaths";

const initialState = {
    users: [],
    loading: false,
    error: null,
};

const userSlice = createSlice({
    name: "users",
    initialState,
    reducers: {
        fetchUsersStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchUsersSuccess: (state, action) => {
            state.loading = false;
            state.users = action.payload;
        },
        fetchUsersFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchUsersStart, fetchUsersSuccess, fetchUsersFailure } = userSlice.actions;

export default userSlice.reducer;

export const fetchUserData = () => async (dispatch) => {
    try {
        dispatch(fetchUsersStart());
        const response = await getApi(`${API_PATHS.USER}?allData=true`)
        dispatch(fetchUsersSuccess(response?.data?.data || [])); 
    } catch (error) {
        dispatch(fetchUsersFailure(error.message || constant.failedToLoadUser));
    }
};
